import React from 'react';
import UniversalComponent from 'utils/universalComponent';

export default props => <UniversalComponent page="reviewModal" {...props} />;
